<template>
    <div id="home-banner" class="bg-secondary">
        <div id="header-carousel" class="carousel slide" data-ride="carousel" data-interval="5000">
            <ol class="carousel-indicators">
                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
            </ol>
            <div class="carousel-inner" style="width: 100% !important; height: 900px;" ref="carousel">
                <div class="carousel-item" v-for="(slide, key) in slides" :key="key">
                    <img class="" :src="slide.image" alt="First slide">
                    <div class="carousel-caption d-md-block">
                        <h1 class="carousel-title text-white" v-text="slide.title"></h1>
                        <p class="carousel-subtitle" v-text="slide.subtitle"></p>
                    </div>
                </div>
            </div>
        </div>

        <login-form></login-form>

    </div>
</template>

<script>
import { resource } from "@utils/network";
const LoginForm = () => import("./LoginForm");

export default {
    name: "CarouselSection",

    components: {
        LoginForm
    },

    data: () =>({
        slides: [{
            image: resource("images/slide-1.jpg"),
            title: "Highly Skilled Personel",
            subtitle: "Cutiefy accredited service providers are legitimate and registered businesses with well-trained personnel"
        },{
            image: resource("images/slide-2.jpg"),
            title: "Bond with Friends and Family",
            subtitle: "Make beautification a family bonding event by booking your services all at the same time"
        },{
            image: resource("images/slide-3.jpg"),
            title: "Convenient and Easy to Use",
            subtitle: "Book your appointments when you need it and where you want it done at a salon, spa, or aesthetic clinic nearest your preferred location"
        }]
    }),

    mounted() {
        this.$refs.carousel.children[0].classList.add("active")
    }
}
</script>

<style scoped lang="css">
    .remember-me-wrapper {
        position: relative;
    }
    .carousel-indicators li {
        cursor: default;
    }
</style>